const b = {
  "blur-0": "blur(0px)",
  "blur-1": "blur(2px)",
  "blur-2": "blur(4px)",
  "blur-3": "blur(8px)",
  "blur-4": "blur(12px)",
  "blur-5": "blur(16px)",
  "blur-6": "blur(20px)",
  "blur-7": "blur(24px)",
  "blur-8": "blur(28px)",
  "blur-9": "blur(32px)",
  "blur-10": "blur(36px)"
}, l = {
  "blur-0": "blur(0px)",
  "blur-1": "blur(2px)",
  "blur-2": "blur(4px)",
  "blur-3": "blur(8px)",
  "blur-4": "blur(12px)",
  "blur-5": "blur(16px)",
  "blur-6": "blur(20px)",
  "blur-7": "blur(24px)",
  "blur-8": "blur(28px)",
  "blur-9": "blur(32px)",
  "blur-10": "blur(36px)"
};
export {
  b as blur,
  l as blurMobile
};
